import { render } from "./Awards.vue?vue&type=template&id=19eb7b76"
import script from "./Awards.vue?vue&type=script&lang=js"
export * from "./Awards.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__